import React from "react";
import { EditFeaturedSectionContentModalTemplate } from "themes/administration/naki-mobile/components";

function EditFeaturedSectionContentModal(props) {
    return <EditFeaturedSectionContentModalTemplate {...props} />;
}

export default EditFeaturedSectionContentModal;
